module.exports = __webpack_public_path__ + "img/santiago_background.b2f36d3f.png";